import Column from '@components/Column';
import Row from '@components/Row';
import Text from '@components/Text';
import Tooltip from '@components/Tooltip';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import CloseInCircleIcon from '@icons/CloseInCircleIcon';
import { ItemOption } from '@models/item';
import { useFlow } from '@router/stackflow';
import useCalculatedOrder from '@store/item/hooks/useCalculatedOrder';
import useOptionControl from '@store/item/hooks/useOptionControl';
import { useSetAtom } from 'jotai';
import { Fragment, useContext } from 'react';

import NextIcon from './NextIcon';
import styles from './styles.module.scss';
import { isPersonalOptionOpenAtom } from '../../atoms/itemOptionAtoms';

interface Props {
    itemId: string;
}

function PersonalOptionButton({ itemId }:Props) {
  const setOpen = useSetAtom(isPersonalOptionOpenAtom);
  const { orderLines } = useCalculatedOrder();
  const { removeOption, resetPersonalOptions } = useOptionControl({ itemId });
  const optionsWithGroups = orderLines
    .map((line) => line.personalOptions).flat()
    .filter((og) => og.options.length !== 0); // 선택된 옵션만 표시
  const { push } = useFlow();
  return (
      <Container>
          <Row className={styles.container}
               onClick={() => {
                 // setOpen(true);
                 push('PersonalOptionActivity', { itemId });
               }}
               fullWidth
               justify='space-between'>
              <Text size='lg' fontWeight='bold'>퍼스널 옵션</Text>
              <NextIcon/>
              <Tooltip visibleKey='personalOption' top={-16} align='right' right={4}>
                  원하는 조합의 옵션을 선택해주세요
              </Tooltip>
          </Row>
          {optionsWithGroups.length !== 0 ? (
              <Column spacing={16}
                      className={styles.contents}
                      fullWidth >
                  <Row justify='flex-end'
                       fullWidth >
                      <Text color={colors.primary}
                            className={styles.reset}
                            onClick={resetPersonalOptions} >
                          전체 초기화
                      </Text>
                  </Row>
                  {optionsWithGroups.map((optionGroup) => {
                    const { options, optionGroupId } = optionGroup;
                    return (
                          <Fragment key={optionGroupId}>
                              {options.map((option) => {
                                const itemOption: ItemOption = {
                                  optionId: option.shopOptionId,
                                  name: option.optionName,
                                  basePrice: option.optionPrice,
                                  salePrice: option.optionPrice,
                                  isDefault: false,
                                  isChangeable: true,
                                  imageUrls: [],
                                  maxQuantity: option.maxQuantity,
                                };
                                return (
                                      <Row key={`${option.shopOptionId} ${optionGroupId}`} spacing={4}>
                                          <Text>{option.optionName} ({option.quantity.toLocaleString()})</Text>
                                          <Text color={colors.gray5}>
                                              +{(option.optionPrice * option.quantity).toLocaleString()}원
                                          </Text>
                                          <CloseInCircleIcon color={colors.gray4}
                                                             onClick={() => removeOption({ option: itemOption, optionGroupId })} />
                                      </Row>
                                );
                              })}
                          </Fragment>
                    );
                  })}
              </Column>
          ) : (<Spacer/>)}
      </Container>
  );
}

const Container = styled.div`
    width: 100%;
`;

const Spacer = styled.div`
    height: 14px;
`;

export default PersonalOptionButton;
